export default "__VITE_ASSET__CjEDogQV__"